import React from 'react';

const ContactMap = () => {
  return (
    <div
      className="
        mx-[calc(50%-50vw)] w-screen
        md:mx-auto md:w-4/5
        h-96 md:mt-6
      "
    >
      <iframe
        title="Match Medic Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3005.9387553888196!2d29.018322411549992!3d41.11402861278711!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab5a10e9dca99%3A0x61175a3501778!2sKolektif%20House%20Maslak!5e0!3m2!1sen!2str!4v1745592883650!5m2!1sen!2str"
        width="100%"
        height="100%"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0 }}
      />
    </div>
  );
};

export default ContactMap;
